import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compliance",
  "use": "compliance-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"compliance\"><path d=\"M195.74 317.74a11.51 11.51 0 0 0 8.52 0c50.43-20.07 97-55.72 97-111.75v-80.71a6 6 0 0 0-5.61-6c-37-2.71-67.06-19.84-92.19-36.8a6.16 6.16 0 0 0-6.88 0c-25.13 17-55.22 34.09-92.19 36.8a6 6 0 0 0-5.61 6V206c-.02 56 46.53 91.67 96.96 111.74zM200 81.75v236.64\" fill=\"none\" stroke=\"#3c4859\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"13\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol